import { useMediaQuery } from "@mui/material";

export const useResponsivePixel = () => {
    const xsPixel = useMediaQuery('(min-width:0px)');
    const smPixel = useMediaQuery('(min-width:600px)');
    const mdPixel = useMediaQuery('(min-width:900px)');
    const lgPixel = useMediaQuery('(min-width:1200px)');
    const xlPixel = useMediaQuery('(min-width:1536px)');

    return {
        xsPixel,
        smPixel,
        mdPixel,
        lgPixel,
        xlPixel
    }
}